import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import AppWrapper from './containers/app';
import store from './redux/store';
import 'swiper/css';
import loadEnv from './constants/env';
import globalStyle from './styles/global.module.less';

import './i18n';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router } from 'react-router-dom';
import QueryStringTracker from './utils/query-string-tracker';

Sentry.init({
  environment: loadEnv.ENVIRONMENT,
  dsn: loadEnv.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/lawconnect\.com\/api/,
    /^https:\/\/staging.lawconnect\.com\/api/,
    /^https:\/\/development.lawconnect\.com\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

document.body.className = globalStyle.bodyRoot;

// Set feature flags globally for react-components to access
interface LawConnectWindow extends Window {
  __LAWCONNECT_CONFIG__?: {
    featureFlags: Record<string, unknown>;
  };
}

(window as LawConnectWindow).__LAWCONNECT_CONFIG__ = {
  featureFlags: {
    diyWill: loadEnv.FEATURE_FLAG.DIY_WILL,
    // Add more feature flags here as needed
  },
};

// todo: remove strict mdoe
ReactDOM.createRoot(document.getElementById('root')!).render(
  <KindeProvider
    clientId={loadEnv.KINDE_CLIENT_ID}
    domain={loadEnv.KINDE_DOMAIN}
    redirectUri={loadEnv.KINDE_REDIRECT_URI}
    logoutUri={loadEnv.KINDE_LOGOUT_REDIRECT_URI}
    audience={loadEnv.KINDE_AUDIENCE}
    scope='offline openid profile email'
  >
    <Provider store={store}>
      <Router>
        <QueryStringTracker />
        <AppWrapper />
      </Router>
    </Provider>
  </KindeProvider>
);
